import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import RoleService from "../../../services/KangarooServices/RoleService";

const AddRole = ({ isOpen, toggle, fetchData, id }) => {
  const [details, setDetails] = useState(null);


  const fetchDetail = async (id) => {
    console.log("called")
    console.log(id)
    try {
      const response = await RoleService.getbyId(id);
      setDetails(response);
      console.log("Called",response)

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("Called")
    console.log(details)
    if (id) {
      fetchDetail(id);
    } else {
      setDetails(null);
    }
  }, [id]);
  console.log(details)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: details?.name || "",
      description: details?.description || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Role name is required"),
      description: Yup.string().nullable(),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        if (id) {
          await RoleService.update(id, values);
          toast.success("Role updated successfully");
        } else {
          await RoleService.create(values);
          toast.success("Role created successfully");
        }
        resetForm();
        // setDetails(null);
        toggle();
        fetchData();
      } catch (error) {
        console.error(error);
        toast.error(id ? "Failed to update role" : "Failed to create role");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleModalClose = () => {
    formik.resetForm();
    setDetails(null);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose}>
      <ModalHeader toggle={handleModalClose}>
        {id ? "Update Role" : "Create New Role"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label for="name">
              Role Name <span className="text-danger">*</span>
            </Label>
            <Input
              id="name"
              name="name"
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.name && Boolean(formik.errors.name)}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="text-danger mt-1">{formik.errors.name}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="description">Description</Label>
            <Input
              id="description"
              name="description"
              type="textarea"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.description && formik.errors.description && (
              <div className="text-danger mt-1">
                {formik.errors.description}
              </div>
            )}
          </FormGroup>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-danger"
          onClick={handleModalClose}
          disabled={formik.isSubmitting}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={formik.handleSubmit}
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? "Processing..." : id ? "Update" : "Create"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AddRole;